import { styled } from "@mui/material";
import { Help } from "@mui/icons-material";

export const StyledHelp = styled(Help)(({ theme }) => ({
  color: theme.palette.info.main,
  cursor: "pointer",
}));
